import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaHome, FaShoppingBag } from 'react-icons/fa';

const ThankYouPage = () => {
    const navigate = useNavigate();

    const handleContinueShopping = () => {
        navigate('/shop');
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-purple-50 flex items-center justify-center p-4">
            <div className="w-full max-w-lg">
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-green-500 to-emerald-600 p-8 text-center">
                        <div className="inline-block bg-white rounded-full p-5 mb-6">
                            <FaCheckCircle className="text-6xl text-green-500 animate-pulse" />
                        </div>
                        <h1 className="text-3xl font-bold text-white mb-3">
                            ধন্যবাদ!
                        </h1>
                        <p className="text-xl text-white text-opacity-95">
                            আপনার অর্ডার কনফার্ম হয়েছে
                        </p>
                    </div>

                    {/* Content */}
                    <div className="p-8">
                        {/* Confirmation Message */}
                        <div className="text-center mb-8">
                            <p className="text-gray-600 text-lg mb-6">
                                আপনার অর্ডারটি সফলভাবে গ্রহণ করা হয়েছে। আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব।
                            </p>
                            
                            <div className="bg-blue-50 rounded-xl p-4 mb-6">
                                <p className="text-gray-700 font-medium mb-2">
                                    কোনো প্রশ্ন থাকলে কল করুন:
                                </p>
                                <p className="text-blue-600 font-bold text-2xl">
                                    01977735432
                                </p>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="space-y-4">
                            <button
                                onClick={handleContinueShopping}
                                className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 px-6 rounded-xl font-bold text-lg shadow-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 flex items-center justify-center"
                            >
                                <FaShoppingBag className="mr-3 text-xl" />
                                আরও পণ্য কিনুন
                            </button>
                            
                            <button
                                onClick={() => navigate('/')}
                                className="w-full bg-gradient-to-r from-gray-600 to-gray-700 text-white py-4 px-6 rounded-xl font-bold text-lg shadow-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-300 flex items-center justify-center"
                            >
                                <FaHome className="mr-3 text-xl" />
                                হোম পেজে ফিরে যান
                            </button>
                        </div>

                        {/* Footer Note */}
                        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
                            <p className="text-gray-500 text-sm">
                                অর্ডার আপডেট পেতে এসএমএস এর অপেক্ষা করুন
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYouPage;